import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { AuthorizationEmail } from 'src/app/shared/models/authorizationEmail.model';
import { EmailService } from 'src/app/shared/services/core/email.service';

@Component({
  selector: 'app-emails-padrao',
  imports: [TegelModule, CommonModule],
  templateUrl: './emails-padrao.component.html',
  styleUrl: './emails-padrao.component.scss'
})
export class EmailsPadraoComponent implements OnInit {
  saveAuthorizationEmailForm!: FormGroup;

  authorizationEmail!: AuthorizationEmail[];
  pageAuthorizationEmail = 1;
  order = "username";

  constructor(private emailService: EmailService,
              private formBuilder: FormBuilder, 
              private utilService: UtilService,
              private dialogService: DialogService,
              private toastr: ToastrService
  ){}

  ngOnInit(): void {
    this.saveAuthorizationEmailForm = this.formBuilder.group({
      username: ['', Validators.required],
      emailAddress: ['', Validators.required]
    });

    this.getAllAuthorizationEmail();
  }

  // chooseUser() {
  //   this.dialogService.addDialog(CollaboratorComponent, {}, this.utilService.getModalOptions()).subscribe((result) => {
  //     if (result && result.user != null) {
  //       const user = result.user;
  //       this.utilService.setFormControl(this.saveAuthorizationEmailForm, 'userName', user.user);
  //       this.utilService.setFormControl(this.saveAuthorizationEmailForm, 'emailAddress', user.email);
  //     }
  //   });
  // }

  updateBusOption(ev: any, id: any, user: any) {
    let value = ev.target.checked ? 'Yes' : 'No';

    this.emailService.updateBusOption(id, value).subscribe((result) => {
      if (result && !result.hasErrors) {
        let index = 0;
        index = this.authorizationEmail.findIndex(c => c.id === id);
        if (index > -1) {
          this.authorizationEmail[index].bus = ev.target.checked ? 'S' : 'N';
        }

        this.toastr.success('Registro alterado.', 'Sucesso');
      }
    });
  }

  updateTruckOption(ev: any, id: string, user: any){
    let value = ev.target.checked ? 'Yes' : 'No';

    this.emailService.updateTruckOption(id, value).subscribe((result) => {
      console.log(result)
      if (result && !result.hasErrors){
        let index = 0;
        index = this.authorizationEmail.findIndex(c => c.id === id);
        if (index > -1){
          this.authorizationEmail[index].truck = ev.target.checked ? 'S' : 'N';
        }

        this.toastr.success('Registro alterado.', 'Sucesso');
      }
    });
  }

  delete(id: string, user: string) {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir a autorização de email do usuário ' + user + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed){
        this.emailService.deleteAuthorizationEmail(id).subscribe((result) => {
          if (result && !result.hasErrors){
            let index = 0;
            do {
              index = this.authorizationEmail.findIndex(c => c.id === id);
              if (index > -1) {
                this.authorizationEmail.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  getAllAuthorizationEmail(){
    this.emailService.getAuthorizationEmail().subscribe((result) => {
      if (result) {
        this.authorizationEmail = result;
      }
    });
  }

  insertAuthorizationEmail() {
    this.emailService.insertAuthorizationEmail(this.saveAuthorizationEmailForm.value).subscribe((resultService) => {
      if (resultService && !resultService.hasErrors){
        this.authorizationEmail.unshift(resultService.content);
        this.utilService.setFormControl(this.saveAuthorizationEmailForm, "userName", '');
        this.utilService.setFormControl(this.saveAuthorizationEmailForm, "emailAddress", '');
        this.toastr.success('Registro salvo.', 'Sucesso');
      }
    });
  }

}
